module.exports = __webpack_public_path__ + "static/honorsclub_obj3@2x-a325ee61052252cd0d5e70fcf3087377.png";